import GradedExamResult from './GradedExamResult';

export default GradedExamResult;
